<!--
 * @Author: your name
 * @Date: 2021-01-04 09:36:15
 * @LastEditTime: 2021-01-07 09:25:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \sunshineServiceHall\src\components\work\telephoneInfo.vue
-->
<template>
  <div style="width: 1200px">
    <div class="tablez_bg">
      <div class="title">
        您当前的位置：
        <router-link target="_blank" class="routerLink" to="/home"
        >阳光校务服务大厅
        </router-link>
        &gt;
        <router-link target="_blank" class="routerLink" to="/work/telephone">报修电话</router-link>
        &gt; 正文
      </div>
    </div>
<!--    <div class="orgTitle center">报修电话</div>-->
<!--    <div class="orgTime center">-->
<!--      文字来源：本站原创  发布时间： 2021年01月06日 10:41:23-->
<!--    </div>-->
    <a-table
        bordered
        rowkey="id"
        style="margin-top: 10px"
        :columns="columns1"
        :data-source="list"
        :pagination="false"
    >
      <div
          style="max-width: 800px; text-align: left"
          slot="list"
          slot-scope="t, r"
      >
        <div
            style="
            width: 33.33%;
            float: left;
            text-align: left;
            line-height: 30px;
          "
            v-for="(item, index) in r.list"
            :key="index"
        >
          {{ item.name }}
        </div>
      </div>
    </a-table>
  </div>
</template>

<script>
import {postAction} from "@/api/manage";

export default {
  data() {
    return {
      columns1: [
        {
          title: "序号",
          align: "center",
          width: 80,
          customRender: (t, r, i) => {
            return i + 1;
          },
        },
        {
          title: "维修项目",
          dataIndex: "name",
          align: "center",
          width: 300,
        },
        {
          title: "联系人",
          align: "center",
          dataIndex: "userName",
        },
        {
          title: "联系电话",
          align: "center",
          dataIndex: "phone",
        },
      ],
      list: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      postAction("/guide/repair/list").then((data) => {
        this.list = data.data;
        console.log(this.list);
      });
    },
  },
};
</script>

<style scoped>
.center {
  width: 100%;
  text-align: center;
}

.orgTitle {
  padding-top: 20px;
  font-family: 宋体;
  font-size: 22pt;
  font-weight: bold;
}

.orgTime {
  padding-top: 10px;
  font-size: 12px;
  color: #999;
}

.orgTitle2 {
  font-weight: bold;
  margin-top: 15px;
  font-family: 仿宋_GB2312;
  font-size: 14pt;
}
</style>
